import renameKeys from 'deep-rename-keys'
import { merge } from 'lodash'
import { POST } from '@/api'
import edit from './edit'

const DETAIL = {
  token: null,
  rsvId: null,
  customer: {
    firstName: '',
    firstNameKana: '',
    lastName: '',
    lastNameKana: '',
  },
  reserveDatetime: null,
  adults: 0,
  children: 0,
  smokingType: 0,
  type: 0,
  courses: [],
  gnaviCourses: [],
  lang: 'ja',
  confirmFlg: false,
  otherTxt: '',
}

const COURSE = {
  names: {
    ja: null,
    en: null,
  },
  price: null,
  tax: 0,
}

const GNAVI_COURSE = {
  name: null,
  image: null,
  description: null,
  price: {
    fixed: null,
    fixedTaxIn: null,
    discounted: null,
    discountedTaxIn: null,
  },
  kind: null,
  persons: {
    min: null,
    max: null,
  },
  menu: {
    count: null,
    text: null,
    notes: [],
  },
  drinkMenu: {
    count: {
      num: null,
      prefix: 0,
      suffix: 0,
    },
    items: [],
    notes: [],
  },
  notes: [],
}

/**
 * 予約詳細
 */
export default {
  namespaced: true,
  state: {
    detail: DETAIL,
    busy: false,
  },
  modules: {
    edit,
  },
  mutations: {
    segment(state, segment) {
      state.segment = segment
    },
    set(state, { courses = [], gnaviCourses = [], ...detail }) {
      state.detail = merge({}, DETAIL, detail, {
        courses: courses.map(course => merge({}, COURSE, course)),
        gnaviCourses: gnaviCourses.map(gnaviCourse => merge({}, GNAVI_COURSE, gnaviCourse)),
      })
    },
    busy(state, busy = false) {
      state.busy = busy
    },
  },
  actions: {
    async get({ commit, rootState }, token) {
      commit('busy', true)

      const res = await POST(`/${rootState.reception.segment}/api/web/reservation/${token}/detail`)
      if (res.status === 200) {
        const { reservation, customer, ...data } = res.data
        commit('set', {
          token,
          ...data,
          ...renameKeys(reservation, key => ({ jpn: 'ja', eng: 'en' }[key] || key)),
          customer,
        })
      } else {
        commit('error/message', res.message, { root: true })
      }

      commit('busy', false)
      return res.status === 200
    },
    async confirm({ commit, state, rootState }) {
      commit('busy', true)

      const res = await POST(`/${rootState.reception.segment}/api/web/reservation/${state.detail.token}/confirm`)
      if (res.status !== 200) {
        commit('error/message', res.message, { root: true })
      }

      commit('busy', false)
      return res.status === 200
    },
  },
}
